import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const vanStockReportListTodo = createAsyncThunk('vanStockReportList', async ({ values, navigate }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: process.env.REACT_APP_API_URL + `van-stock-available`,
            data: {
                "date": values.date,
                "wareHouseId": values.ware_house,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const vanStockReportListSlice = createSlice({
    name: 'vanStockReportList',
    initialState: {
        data: [],
        isLoading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(vanStockReportListTodo.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(vanStockReportListTodo.fulfilled, (state, action) => {
            state.isLoading = false;
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(vanStockReportListTodo.rejected, (state, action) => {
            state.isLoading = false;
            state.data = [];
        })
    }
})

export default vanStockReportListSlice.reducer;